import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as postAction from './../../../../actions/postAction';
import Posts from './Posts';

const mapStateToProps = state => {
    return {
        postState: state.postReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListPosts: (filters) => dispatch(postAction.getListPosts(filters)),
        deletePostDetail: (post, filters) => dispatch(postAction.deletePostDetail(post, filters)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Posts));
